// getShopData.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import { EMPTY_ARRAY } from '../resource/defaults.js';
import { ShopModalType, ShopSectionType } from '../resource/shopConstants.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Select the shop sections fetched from `/shop/sections` for a shop.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} shopId - shop id.
 * @return {array} The shop sections, e.g. ['anchor=nu_pass', 'section=general'].
 */
export const getShopSections = (state, shopId) =>
  getOperationData(state, ['shop', shopId], 'sections') || EMPTY_ARRAY;

/**
 * Select whether the current shop is a quickpay shop, as told by the backend.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} shopId - shop id.
 * @return {boolean} Whether the shop modal type is quickpay.
 */
export const getIsQuickpay = (state, shopId) =>
  getOperationData(state, ['shop', shopId], 'modalType') ===
  ShopModalType.QUICKPAY;

/**
 * Select the first section id of the shop sections.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} shopId - shop id.
 * @return {string} The first section id.
 */
export const getShopFirstSectionId = createCachedSelector(
  (state, shopId) => getShopSections(state, shopId),
  sections =>
    sections
      .find(section => section.startsWith(`${ShopSectionType.SECTION}=`))
      ?.split('=')[1] || ''
)((state, shopId) => `${shopId}`);
